import paymentSuccessIcon from '../../assets/img/payment/paymentSuccess.png';
import paymentFailedIcon from '../../assets/img/payment/paymentFailed.png';

export const initialPaymentStatusPopupState = {
    isVisible: false,
    config: {
        title: '',
        icon: '',
        variant: '',
        message: '',
        confirmBtnText: '',
        cancelBtnText: '',
        confirmBtnLoading: false,
        cancelBtnLoading: false,
        onConfirmKey: null,
        onCancelKey: null,
        textWhileProcessingConfirmBtn: 'Saving...',
        textWhileProcessingCancelBtn: 'Saving...',
    }
};

export const PAYMENT_STATUS_POPUP = {
    SUCCESS: {
        TITLE: 'Payment Successful',
        ICON: paymentSuccessIcon,
        VARIANT: 'success',
        MESSAGE: 'Would you like to begin your assessment now?',
        CONFIRM_BTN_TEXT: 'Start Now',
        CANCEL_BTN_TEXT: 'Start Later',
        TEXT_WHILE_PROCESSING_CONFIRM_BTN: 'Starting...',
        TEXT_WHILE_PROCESSING_CANCEL_BTN: 'Loading...',
    },

    FAILED: {
        TITLE: 'Payment Failed',
        ICON: paymentFailedIcon,
        VARIANT: 'failed',
        MESSAGE: 'Something went wrong with your payment. Please try again.',
        CONFIRM_BTN_TEXT: 'Retry',
        CANCEL_BTN_TEXT: 'Pay Later',
        TEXT_WHILE_PROCESSING_CONFIRM_BTN: 'Retrying...',
        TEXT_WHILE_PROCESSING_CANCEL_BTN: 'Loading...',
    }
}